import type { Graph, WithContext, Thing } from 'schema-dts';

import getWebSite from './JsonLD/getWebSite';
import getWebPage from './JsonLD/getWebPage';
import getWebPageWithBreadcrumb from './JsonLD/getWebPageWithBreadcrumb';
import getArticle from './JsonLD/getArticle';
import getBreadcrumbList from './JsonLD/getBreadcrumbList';

type JsonLdHandler = (data: App.PageData, types: string[]) => Graph | WithContext<Thing> | null;

const handlers: { [k: string]: (data: App.PageData) => Thing } = {
  WebSite: getWebSite,
  WebPage: getWebPage,
  WebPageWithBreadcrumb: getWebPageWithBreadcrumb,
  Article: getArticle,
  BreadcrumbList: getBreadcrumbList,
};

const getJsonLd: JsonLdHandler = (data, types = ['WebSite']) => {
  const schemes = types.map((type) => handlers[type](data));

  if (schemes.length <= 0) {
    return null;
  }

  if (types.length > 1) {
    const graph: Graph = {
      '@context': 'https://schema.org',
      '@graph': schemes,
    };
    return graph;
  }

  const thing: WithContext<Thing> = Object.assign(
    { '@context': 'https://schema.org' },
    schemes[0],
  ) as WithContext<Thing>;
  return thing;
};

export default getJsonLd;
